import React from 'react';
import ReactDOM from "react-dom/client";



const learning_30_05_2025 = () => (
   <div>
      learning_30_05_2025 Component


      <h1>Hello Style!</h1>
      <p>Add a little style!.</p>

      <div>
         <h1>My favorite color is color!</h1>

         <button
            type="button"

         >Blue</button>
         <br />
         <button
            type="button"

         >red</button>

         <br />
         <button
            type="button"

         >pink</button>


         <br />
         <button
            type="button"

         >green</button>
      </div>
      <div>
         <h1>
            Hello Jesse Hall!


         </h1>

         <h1>
            Component 2
         </h1>
         <h1>
            Component 3
         </h1>
         <h1>
            Component 4
         </h1><h1>
            Component 5
         </h1>

         <h2>
            Hello Jesse Hall again!
         </h2>
      </div>

<div>
   <h2>My Todos

   </h2>
   <p>New todo</p>
   <button type="button"> Add Todo</button>
   <br/>
   <p>Count: <button type="button">+</button></p>

   <h1>Expensive Calculation</h1>
</div>


   </div>
);


learning_30_05_2025.propTypes = {};

learning_30_05_2025.defaultProps = {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<learning_30_05_2025 />);

export default learning_30_05_2025;
